import { Grid as MuiGrid, Button as MuiButton } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * A component for Cancel & Save buttons in forms.
 *
 * @param {{cancel: function, save: Object}} props
 * @returns the Cancel & Save buttons.
 * @example
 * <FormButton
 *   cancel={handleClose}
 *   save={{ disabled: true }}
 * />
 *
 * @author Paras Sahu
 */
export const FormButton = (props) => {
  // `useTranslation` will provide the Locale translation of text labels
  const { t } = useTranslation();
  const isDeleteRecord = props.delete !== undefined;
  return (
    <>
      <MuiGrid size={6}>
        <MuiButton
          onClick={props.cancel}
          color="primary"
          variant="outlined"
          fullWidth
        >
          {t("globals.form.actionButtons.cancel")}
        </MuiButton>
      </MuiGrid>
      {isDeleteRecord ? (
        <MuiGrid size={6}>
          <MuiButton
            onClick={props.delete}
            color="primary"
            variant="outlined"
            fullWidth
          >
            {t("globals.form.actionButtons.delete")}
          </MuiButton>
        </MuiGrid>
      ) : (
        <MuiGrid size={6}>
          <MuiButton
            type="submit"
            color="primary"
            fullWidth
            variant="contained"
            {...props.save}
          >
            {t("globals.form.actionButtons.save")}
          </MuiButton>
        </MuiGrid>
      )}
    </>
  );
};
